import { render, staticRenderFns } from "./PostLikeField.vue?vue&type=template&id=3144d7dd&scoped=true&"
import script from "./PostLikeField.vue?vue&type=script&lang=ts&"
export * from "./PostLikeField.vue?vue&type=script&lang=ts&"
import style0 from "./PostLikeField.vue?vue&type=style&index=0&id=3144d7dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3144d7dd",
  null
  
)

export default component.exports